<script>
    import { store } from '../../Store.svelte';

    export let item = {};
    let checked = false;

    store.subscribe((value) => {
        $store.requestedServices.phoneExtras.forEach((extra) => {
            if (extra.extId == item.extId && extra.nuevaCantidad > 0) {
                checked = true;
            }
        });
    });

    function onclick() {
        if (checked) {
            let selectedExtras = $store.requestedServices.phoneExtras;
            selectedExtras.push({
                extId: item.extId,
                nuevaCantidad: 1,
                extra: {
                    title: item.extra.title,
                    cost: item.extra.cost,
                },
            });
            $store.requestedServices.phoneExtras =
                selectedExtras.filter(removeInvalidExtras);
        } else {
            $store.requestedServices.phoneExtras =
                $store.requestedServices.phoneExtras.filter(removeCurrentExtra);
        }
    }

    function removeInvalidExtras(extra) {
        let invalid = false;
        if (item.extra.extEliminar != null) {
            item.extra.extEliminar.forEach((invalidId) => {
                if (invalidId == extra.extId) {
                    invalid = true;
                }
            });
        }
        return !invalid;
    }

    function removeCurrentExtra(extra) {
        return extra.extId != item.extId;
    }
</script>

<div class="label__selectable_wrapper m-b-15">
    <input
        type="checkbox"
        id="phoneaddon_{item.extId}"
        name="phoneaddon_{item.extId}"
        bind:checked
        on:change={onclick}
    />
    <label for="phoneaddon_{item.extId}" class="label__selectable">
        <span class="label__selectable__indicator"
            ><img
                src="/assets/img/icons/check.svg"
                alt=""
                aria-hidden="true"
            /></span
        >
        <div class="label__description">
            <div class="h2 text-fs-20 fw-semibold m-b-5">
                {item.extra.title}
            </div>
            {#if item.extra.description != null}
                <p class="text-fs-13 m-b-0">{item.extra.description}</p>
            {/if}
        </div>
        <div class="label__pricing">
            <div class="h2 text-fs-23 fw-semibold primary-text">
                +$<span>{item.extra.cost}</span>
            </div>
            <p class="text-fs-15">al mes</p>
        </div>
        <div class="label__action pure__button">
            <span class="on-uncheck">Seleccionar</span><span class="on-check"
                >Quitar</span
            >
        </div>
    </label>
</div>
